import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiNewsService } from '../../../../services/news/api/api-news.service';
import { AlertsService } from '../../../../services/alerts.service';
import { ModalsService } from '../../../../services/modals.service';
import { NewsReward } from '../../../../models/news/news-reward.model';
import { UserCurrencyType } from '../../../../enums/users/user-currency-type.enum';
import { NewsRewardAddModalComponent } from '../news-reward-add-modal/news-reward-add-modal.component';
import { NewsRewardEditModalComponent } from '../news-reward-edit-modal/news-reward-edit-modal.component';

@Component({
  selector: 'app-news-rewards-modal',
  templateUrl: './news-rewards-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, NewsRewardAddModalComponent, NewsRewardEditModalComponent]
})
export class NewsRewardsModalComponent {

  @ViewChild('modal') modal!: ModalDirective;
  @ViewChild('newsRewardAddModal') newsRewardAddModal!: NewsRewardAddModalComponent;
  @ViewChild('newsRewardEditModal') newsRewardEditModal!: NewsRewardEditModalComponent;

  newsId: number = 0;
  newsName: string = '';
  rewards: NewsReward[] = [];

  readonly currencyTypes = Object.entries(UserCurrencyType).filter(([, v]) => typeof v === 'number') as [string, number][];

  private callbackChanged?: () => void;

  constructor(
    private apiNewsService: ApiNewsService,
    private alertsService: AlertsService,
    private modalsService: ModalsService
  ) {}

  getCurrencyTypeName(type: number): string { return UserCurrencyType[type] ?? String(type); }

  show(newsId: number, newsName: string, rewards: NewsReward[], callbackChanged?: () => void): void {
    this.newsId = newsId;
    this.newsName = newsName;
    this.rewards = [...rewards];
    this.callbackChanged = callbackChanged;
    this.modal.show();
  }

  onClickAddReward(): void {
    this.newsRewardAddModal.show(this.newsId, () => { if (this.callbackChanged) { this.callbackChanged(); } });
  }

  onClickEditReward(reward: NewsReward): void {
    this.newsRewardEditModal.show(reward, () => { if (this.callbackChanged) { this.callbackChanged(); } });
  }

  onClickDeleteReward(reward: NewsReward): void {
    this.modalsService.showConfirmModal(() => {
      this.apiNewsService.deleteNewsReward(reward.rewardId).then(
        () => {
          this.alertsService.displayAlertSuccess('Reward deleted !');
          if (this.callbackChanged) { this.callbackChanged(); }
        }, error => {
          this.alertsService.displayAlertError('Error deleting reward : ' + error);
        }
      );
    });
  }
}
